import React from "react";
import { Link } from "react-router-dom";

import {
    Row,
    Col,
    Box,
    CampoEstatico,
    TipoCampoEstatico,
    PosicaoTituloCampoEstatico,
} from "@intechprev/componentes-web";

import { Page } from "../";
import { Contracheques } from "./Contracheques";
import { ContrachequeDetalhe } from "./ContrachequeDetalhe";
import {
    PlanoVinculadoService,
    ProcessoBeneficioService,
    FichaFinancAssistidoService,
} from "../../services";
import {
    PlanoVinculadoEntidade,
    ProcessoBeneficioEntidade,
    FichaFinancAssistidoEntidade,
} from "../../entidades";

export { Contracheques, ContrachequeDetalhe };

interface Props {}

interface State {
    plano: PlanoVinculadoEntidade;
    processo: ProcessoBeneficioEntidade;
    datasFicha: Array<FichaFinancAssistidoEntidade>;
}

export class Beneficios extends React.Component<Props, State> {
    private page = React.createRef<Page>();

    constructor(props: Props) {
        super(props);

        this.state = {
            plano: new PlanoVinculadoEntidade(),
            processo: new ProcessoBeneficioEntidade(),
            datasFicha: new Array<FichaFinancAssistidoEntidade>(),
        };
    }

    componentDidMount = async () => {
        await this.page.current.loading(true);

        var planos = await PlanoVinculadoService.Buscar();
        var plano = planos[0];
        var processo = await ProcessoBeneficioService.BuscarPorPlano(
            plano.SQ_PLANO_PREVIDENCIAL
        );
        var datasFicha = await FichaFinancAssistidoService.BuscarDatasPorProcesso(
            processo.SQ_PROCESSO
        );

        await this.setState({ plano, processo, datasFicha });

        await this.page.current.loading(false);
    };

    render() {
        return (
            <Page {...this.props} ref={this.page}>
                <Row>
                    <Col tamanho={"lg-6"}>
                        <Box>
                            <div className="form-row">
                                <CampoEstatico
                                    titulo={"Plano"}
                                    valor={
                                        this.state.plano.DS_PLANO_PREVIDENCIAL
                                    }
                                    posicaoTitulo={
                                        PosicaoTituloCampoEstatico.cima
                                    }
                                />
                                <CampoEstatico
                                    titulo={"Processo"}
                                    valor={`${this.state.processo.NR_PROCESSO}/${this.state.processo.NR_ANO_PROCESSO}`}
                                    posicaoTitulo={
                                        PosicaoTituloCampoEstatico.cima
                                    }
                                />
                            </div>

                            <div className="form-row">
                                <CampoEstatico
                                    titulo={"Benefício"}
                                    valor={this.state.processo.DS_ESPECIE}
                                    posicaoTitulo={
                                        PosicaoTituloCampoEstatico.cima
                                    }
                                />
                                <CampoEstatico
                                    titulo={"Data Concessão"}
                                    valor={this.state.processo.DT_CONCESSAO}
                                    posicaoTitulo={
                                        PosicaoTituloCampoEstatico.cima
                                    }
                                />
                            </div>

                            <div className="form-row">
                                <CampoEstatico
                                    titulo={"Situação"}
                                    valor={this.state.processo.DS_MOT_SITUACAO}
                                    posicaoTitulo={
                                        PosicaoTituloCampoEstatico.cima
                                    }
                                />
                            </div>

                            <Link
                                className="btn btn-primary btn-block mt-3"
                                id="esqueciSenha"
                                to="/contracheques"
                            >
                                Demonstrativos de Pagamento - Contracheque
                            </Link>
                        </Box>
                    </Col>
                </Row>
            </Page>
        );
    }
}
